export default __webpack_public_path__ + "static/media/thbi-04.777dd207.png";